import React, { forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDsTokens } from '../theme/useDsTokens';
import { cn } from '../utils/cn';
import { DsCommonProps, DsValidationProps } from './types';

export interface LabelProps extends DsCommonProps, DsValidationProps {
  htmlFor: string;
  children: React.ReactNode;
}

const useStyles = makeStyles(() => ({
  root: {
    display: 'block',
    marginBottom: 4,
  },
  required: {
    marginLeft: 2,
  },
}));

export const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
  { id, htmlFor, children, className, disabled, error, required, 'data-testid': testId },
  ref
) {
  const tokens = useDsTokens();
  const classes = useStyles();

  return (
    <label
      ref={ref}
      id={id}
      htmlFor={htmlFor}
      className={cn(classes.root, className)}
      data-testid={testId}
      style={{
        fontSize: tokens.fontSizeBody,
        fontWeight: tokens.fontWeightMedium,
        color: disabled
          ? tokens.textDisabled
          : error
            ? tokens.statusError
            : tokens.textSecondary,
        opacity: disabled ? tokens.opacityDisabled : 1,
      }}
    >
      {children}
      {required && (
        <span className={classes.required} aria-hidden="true">
          *
        </span>
      )}
    </label>
  );
});

Label.displayName = 'Label';
